import { Button } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const OptionsDropdownMenu = styled.div`
  background: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: var(--size-padding-8);
  position: relative;
  width: 100%;
  z-index: 999;

  ${({ color }) => {
    return (
      !color &&
      css`
        ${Button.S.Button}[color="neutral"] {
          color: var(--color-fg-weak);
          &:hover {
            background: var(--color-bg-weakest);
          }
        }
        ${Button.S.Button}[color="error"] {
          color: var(--color-fg-error);
          &:hover {
            background: var(--color-error-weakest);
          }
        }
      `
    );
  }}
`;

export { OptionsDropdownMenu };
